import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  fApproveDetail,
} from "./StockTransferReceiptAction";
import {
  fAlertToast,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import { StockTransferReceipt_DeleteDetail_GETROW } from "../../Server/ApiV2";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import InstantPickingBreadcrumbs from "./StockTransferReceipt_BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";

import "./StockTransferReceipt.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import { Button } from "@mui/material";

export default function StockTransferReceiptDetail() {
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const dispatch = useDispatch();
  const vRdxHead = useSelector(
    (state) => state.SliceStockTransferReceipt.value.HeadObj
  );
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vInitHeadError = {
    DocType: "",
    DocNo: "",
    Date: "",
    Loc: "",
    LocName: "",
    LocTo: "",
    LocNameTo: "",
    A_DocStat: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    DocType: "",
    DocNo: "",
    Date: "",
    Loc: "",
    LocName: "",
    LocTo: "",
    LocNameTo: "",
    A_DocStat: "",
  });

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);
  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item?.R_Srno,
      B_Itmcd: item?.R_Itmcd,
      B_ItmName: item?.ItemName,
      B_Qty: item?.R_Qty,
      B_Unit: item?.R_Unit,
      B_UnitName: item?.UnitName,
      B_BaseQty: item?.R_BaseQty,
    }));
    let currentUnitArr = await GetUnitArr(item?.R_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item?.R_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  };

  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0, //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  });

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd, vRdxHead.Loc);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat?.toUpperCase() !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      fSaveHead(fNewDetail, sBufferObj);
    }, 500);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let CheckDueDate = await GetCheck_Monthend_DueDate(
        vRdxHead.Loc,
        vRdxHead.Date
      );
      if (!CheckDueDate) return;
      let CheckDueDateTo = await GetCheck_Monthend_DueDate(
        vRdxHead.LocTo,
        vRdxHead.Date
      );
      if (!CheckDueDateTo) return;

      fApproveDetail(fNewDetail, dispatch);
    }, 500);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vInitHeadError);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName === "") {
      fNewDetail();
      document?.getElementsByName("B_Qty")[0]?.focus();
    } else {
      fNewDetail();
    }
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("B_Qty")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else if (sBufferObj.B_Srno === 0) {
      fAlertToast("FAILED", "Item not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    let vDeleteSIDetailObj = {
      v_B_VocTyp: vRdxHead.DocType,
      v_B_VocNo: vRdxHead.DocNo,
      v_B_Srno: sBufferObj.B_Srno,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_IP: vRdxUserInfoObj.IP,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await StockTransferReceipt_DeleteDetail_GETROW(
      FinalObj
    );

    if (vDeleteSIDetail?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      // http://94.200.177.214:3010/WMS/StockTransferReceipt?prntyp=C&sheet=80117
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/StockTransferReceipt?TrnTyp=" +
        xPrnTyp +
        "&VocTyp=" +
        vRdxHead?.DocType +
        "&VocNo=" +
        vRdxHead?.DocNo;
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxHead?.DocType, vRdxHead?.DocNo, vRdxDBKernObj]
  );

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
    }
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_ItemName_Toggle) {
        const toggleElement = event.target.closest(".toggleSearch");

        if (!toggleElement) {
          set_GCToggleSearch_ItemName_Toggle(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_ItemName_Toggle]);

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);

  const [Detail_Grid_columns, setDetail_Grid_columns] = useState([
    {
      field: "R_Srno",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "R_Itmcd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 320,
    },
    {
      field: "R_Qty",
      headerName: "Qty",
      width: 50,
      valueFormatter: ({ value }) => {
        Number(value)?.toFixed(Number(3));
      },
    },

    {
      field: "R_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "UnitName",
      headerName: "UnitName",
      width: 100,
    },
    {
      field: "R_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ]);

  useEffect(() => {
    GetGitterColumns(setDetail_Grid_columns, "INV10RCDWB", Detail_Grid_columns);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fLoad_Grid(setDetail_Grid_Row);
  }, []);
  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs">
        <InstantPickingBreadcrumbs />
      </div>

      <div style={{ margin: "auto", width: "98%" }}>
        <Grid container columnSpacing={4} rowSpacing={vMediaQuery ? 0 : 2}>
          <Grid item xs={12} sm={12} md={6}>
            {!vMediaQuery && (
              <WmsHead
                xref={BarcodeFocusOnLoad}
                vRdxHead={vRdxHead}
                xErrorMsg={sErrorMsg}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <WmsContent
              sEnterKeyObj={sEnterKeyObj}
              xContent_Focus={fContent_Focus}
              xContent_Blur={fContent_Blur}
              xErrorMsgDetail={sErrorMsgDetail}
              xBufferObj={sBufferObj}
              sUnit={sUnit}
              fUnit={fUnit}
              fQty={fQty}
              fQty_Enter={fQty_Enter}
              fItemName={GCToggleSearch_ItemName_Main_Input}
              xMediaQuery={vMediaQuery}
              xonClickbtn={GCToggleSearch_ItemName_Main_Enter}
              xrows={GCToggleSearch_ItemName_Grid_Row}
              xcolumns={GCToggleSearch_ItemName_Columns}
              xRowCellClick={GCToggleSearch_ItemName_CellClick}
              xRowClick={GCToggleSearch_ItemName_RowClick}
              xToggle={GCToggleSearch_ItemName_Toggle}
              xData={GCToggleSearch_ItemName_Select_Arr}
              xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input}
              xDropdownObj={GCToggleSearch_ItemName_Obj}
              xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter}
            />

            <Grid
              container
              marginTop={1}
              spacing={vMediaQuery ? 1 : 0}
              sx={{
                textAlign: "right",
                "& .MuiButton-root": {
                  minWidth: { xs: "100%", sm: "80%", md: "85%", lg: "70%" },
                },
              }}
            >
              <Grid item xs={4} sm={2.4} md={2.8}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={fNew}
                  xVariant="contained"
                />
              </Grid>

              <Grid item xs={4} sm={2.4} md={2.4}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="contained"
                  xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                  xColor={"success"}
                />
              </Grid>

              <Grid item xs={4} sm={2.4} md={2.4}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={fDelete}
                  xVariant="contained"
                  xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                  xColor={"error"}
                />
              </Grid>

              <Grid item xs={4} sm={2.4} md={2.4}>
                <CmpButton
                  xbtnName="Approve"
                  xOnClick={fApprove}
                  xVariant="contained"
                  xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                  xColor={"success"}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sm={2.4}
                md={2}
                lg={2}
                className="xs-screen-hide"
                sx={{ textAlign: { xs: "center", sm: "center", md: "right" } }}
              >
                <DropdownButton
                  id="dropdown-basic-button"
                  title="Print"
                  variant="primary"
                  size="xs"
                >
                  <Dropdown.Item
                    id="IdPrint"
                    onClick={(e) => {
                      fPrint("INV10R");
                    }}
                  >
                    Transaction
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("INV10V");
                    }}
                  >
                    Transfer Vs Received
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("INV10");
                    }}
                  >
                    Stock Transfer
                  </Dropdown.Item>
                </DropdownButton>
              </Grid>
              <Grid
                item
                xs={4}
                sm={2}
                md={2.2}
                lg={2.2}
                className="bintransfer-btn-grid-sm-show"
              >
                <CmpButton
                  xbtnName="Detail"
                  xOnClick={fView}
                  xVariant="contained"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<RemoveRedEyeIcon />}
                />
              </Grid>
              <Grid
                item
                xs={4}
                sm={2}
                md={2.2}
                lg={2.2}
                className="bintransfer-btn-grid-sm-show"
              >
                <CmpButton
                  xbtnName="Summary"
                  xOnClick={fSummary}
                  xVariant="contained"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<RemoveRedEyeIcon />}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: "65vh", overflowY: "auto", padding: 0.5 }}>
              <Grid container spacing={2}>
                {Array.isArray(sDetail_Grid_Row) &&
                  sDetail_Grid_Row.length > 0 &&
                  sDetail_Grid_Row.map((item, index) => (
                    <Grid item xs={12} sm={4} md={4} lg={3} key={index}>
                      <DetailCardComp
                        data={item}
                        onClick={() => fDetail_Grid_onRowClick(item)}
                        headerLabel={item?.ItemName}
                        content={
                          <Grid container spacing={1}>
                            <DetailInputDisplay
                              label="Sr No"
                              value={item?.R_Srno}
                            />
                            <DetailInputDisplay
                              label="Item Code"
                              value={item?.R_Itmcd}
                            />
                            <DetailInputDisplay
                              label="Qty"
                              value={item?.R_Qty}
                            />
                            <DetailInputDisplay
                              label="Unit"
                              value={item?.UnitName}
                            />
                            <DetailInputDisplay
                              label="Base Qty"
                              value={item?.R_BaseQty}
                            />
                          </Grid>
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Grid"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "69vh", width: "100%" }}>
              {/* <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetail_Grid_Row}
                columns={Detail_Grid_columns}
                hideFooter={sDetail_Grid_Row.length < 100}
                onRowClick={fDetail_Grid_onRowClick}
              /> */}
              {/* ================= RIGHT SIDE ================= */}
              <Box
                sx={{
                  width: { xs: "100%", md: "40%" },
                  height: "100%",
                  overflowY: "auto",
                }}
              >
                <Grid container spacing={2}>
                  {Array.isArray(sDetail_Grid_Row) &&
                    sDetail_Grid_Row.length > 0 &&
                    sDetail_Grid_Row.map((item, index) => (
                      <Grid item xs={12} sm={6} md={12} key={index}>
                        <DetailCardComp
                          data={item}
                          onClick={() => fDetail_Grid_onRowClick(item)}
                          headerLabel={item?.ItemName}
                          content={
                            <Grid container spacing={1}>
                              <DetailInputDisplay
                                label="Sr No"
                                value={item?.R_Srno}
                              />
                              <DetailInputDisplay
                                label="Item Code"
                                value={item?.R_Itmcd}
                              />
                              <DetailInputDisplay
                                label="Qty"
                                value={item?.R_Qty}
                              />
                              <DetailInputDisplay
                                label="Unit"
                                value={item?.UnitName}
                              />
                              <DetailInputDisplay
                                label="Base Qty"
                                value={item?.R_BaseQty}
                              />
                            </Grid>
                          }
                        />
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </div>
          </div>
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsHead
              xref={BarcodeFocusOnLoad}
              vRdxHead={vRdxHead}
              xErrorMsg={sErrorMsg}
            />
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
